import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * Configures default options for all queries and mutations
 */

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Allow refetching on mount to get latest data
      refetchOnMount: true,
      // Don't refetch on window focus to reduce unnecessary requests
      refetchOnWindowFocus: false,
      // Allow refetch on reconnect to get latest data after network issues
      refetchOnReconnect: true,
      // Keep data fresh for 5 minutes before considering it stale
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Keep unused data in cache for 10 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      // Retry failed queries once with exponential backoff
      retry: 1,
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});
